import React, { useContext } from "react";

import Modal from "@/components/common/modal";
import GlobalContext from "@/contexts/Global/GlobalContext";

import { BADGE_INFO_MODAL_DATA } from "./constants";
import "./styles.scss";

const BadgeInfoModal = () => {
  const { isBadgeModalOpen, closeBadgeModal } = useContext(GlobalContext);

  if (!isBadgeModalOpen) {
    return null;
  }

  return (
    <Modal
      className="badge-info-modal"
      formCloseCallback={closeBadgeModal}
      header={"Уровни экспертов \n Лунаро"}
    >
      <div>
        {BADGE_INFO_MODAL_DATA.map((badge) =>
          (
            <p key={badge.level}>
              <strong>{badge.level}</strong>
              {" "}
              —
              {" "}
              {badge.description}
            </p>
          ))}
      </div>
    </Modal>
  );
};

export default BadgeInfoModal;
